// Protect routes that require authentication by checking for cookie.session_username
import * as Cookies from 'es-cookie';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import RouteList from './Routes';

const RouteAuth = () => {
  const isAuthenticated = !!Cookies.get('session_username');
  const location = useLocation();
  const loginURL = RouteList.login.path + '?return_url=' + encodeURIComponent(window.location.href);

  if (!isAuthenticated) {
    return <Navigate to={loginURL} state={{ from: location }} replace />;
  } else {
    return <Outlet />;
  }
};

export default RouteAuth;
